<div class="content">
  <div class="decision-blocks">
    <h2 [innerHTML]="'change response master decision'"></h2>
    <p>select the correct decision</p>
    <div
      class="decision-block green"
      [ngClass]="{ active: decision === decisionsConst.upheld.id }"
      (click)="changeDecisionStatus(decisionsConst.upheld.id)"
    >
      <span>Upheld</span>
    </div>
    <div
      class="decision-block blue"
      *ngIf="isPcnStageIdSmallerThanCCSent()"
      [ngClass]="{ active: decision === decisionsConst.reqInfo.id }"
      (click)="changeDecisionStatus(decisionsConst.reqInfo.id)"
    >
      <span>Req Info</span>
    </div>
    <div
      class="decision-block red"
      [ngClass]="{ active: decision === decisionsConst.cancel.id }"
      (click)="changeDecisionStatus(decisionsConst.cancel.id)"
    >
      <span>Cancel</span>
    </div>
  </div>
  <div class="reason-decision-blocks">
    <div class="reason-decision-block request-info">
      <div class="block-50">
        <p class="subtitle">Select the reason for the decision*</p>
        <label
          class="question-label radio"
          *ngFor="let option of decisionReasons.optionList"
          [ngClass]="{ selected: option.id === decisionReasons.optionSelected }"
          (click)="decisionReasons.optionSelected = option.id"
        >
          <i class="radio-icon"></i>
          <span [innerHTML]="option.caption"></span>
          <input aria-label="" [value]="option.id" type="radio" />
        </label>
      </div>
      <div class="block-50">
        <p class="subtitle">Please provide additional details*</p>
        <textarea [(ngModel)]="decisionDetails"></textarea>
      </div>
      <div class="clear"></div>

      <div *ngIf="decision === decisionsConst.reqInfo.id">
        <div class="subtitle">
          <br /><br />
          Response Master will create this paragraph:*<br /><br />
          We will reconsider your case if you send us *. You need to do this within 14 days of the
          date of this letter. Please send a photocopy (not the original) and quote your parking
          ticket number (see above).<br /><br />
          In the box below, type the words you want in place of the *. Don't put a full-stop at the
          end - Response Master will. Example: a letter from your dentist about the operation
        </div>
        <textarea class="small" [(ngModel)]="infoDetails"></textarea>
      </div>
      <div
        class="cancel-fields"
        *ngIf="decision === decisionsConst.upheld.id && isPcnStageCCSent()"
      >
        <p class="subtitle cancel-subtitle">
          Do you want to tell the driver it's too late to challenge?
        </p>
        <label
          class="question-label radio"
          *ngFor="let option of challenge.optionList"
          [ngClass]="{ selected: option.id === challenge.optionSelected }"
          (click)="challenge.optionSelected = option.id"
        >
          <i class="radio-icon"></i>
          <span [innerHTML]="option.caption"></span>
          <input aria-label="" [value]="option.id" type="radio" />
        </label>
      </div>
      <div class="cancel-fields" *ngIf="decision === decisionsConst.cancel.id">
        <p class="subtitle cancel-subtitle">Why are we cancelling this PCN?</p>
        <label
          class="question-label radio"
          *ngFor="let option of cancelOptions.optionList"
          [ngClass]="{ selected: option.id === cancelOptions.optionSelected }"
          (click)="cancelOptions.optionSelected = option.id"
        >
          <i class="radio-icon"></i>
          <span [innerHTML]="option.caption"></span>
          <input aria-label="" [value]="option.id" type="radio" />
        </label>
      </div>
    </div>
    <div class="buttons">
      <button class="cancel secondary" (click)="onCloseModal()">
        <span>Cancel</span>
        <!-- <img [src]="constants.assetsPath + '/img/icons/red-bin.svg'" width="14"> -->
      </button>
      <button
        class="change"
        [disabled]="!isChangeDecisionAllowed()"
        (click)="submitChangeDecision()"
      >
        <span [innerHTML]="'Change decision'"></span>
      </button>
    </div>
  </div>
</div>
